"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M12 7.77 18.39 18H5.61zM12 4 2 20h20z"
}), 'ChangeHistorySharp');